/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */

import Information from './pages/Information.vue';
import InformationEdit from './pages/InformationEdit.vue';
import InformationShow from './pages/InformationShow.vue';
import InformationShowAdmin from './pages/InformationShowAdmin.vue';
import Onboarding from './pages/Onboarding.vue';
import AddEditOnboarding from './pages/AddEditOnboarding.vue';
import TrainingPlan from './pages/training/TrainingPlan.vue';
import TrainingPlanEdit from './pages/training/TrainingPlanEdit.vue';
import TrainingPlanShow from './pages/training/TrainingPlanShow.vue';
import Schedule from './pages/Schedule.vue';
import ShowOnboarding from './pages/ShowOnboarding.vue';
import TrainingReportList from './pages/training/TrainingReportList.vue';
import TrainingMatrixReport from './pages/training/TrainingMatrixReport.vue';
import SaveTrainingReport from './pages/training/SaveTrainingReport.vue';
import TrainingReportShow from './pages/training/TrainingReportShow.vue';

export default {
  'training-plan': TrainingPlan,
  'training-plan-edit': TrainingPlanEdit,
  'training-plan-show': TrainingPlanShow,
  onboarding: Onboarding,
  'add-edit-onboarding': AddEditOnboarding,
  'show-onboarding': ShowOnboarding,
  information: Information,
  'information-edit': InformationEdit,
  'information-show': InformationShow,
  'information-show-admin': InformationShowAdmin,
  schedule: Schedule,
  'training-report-list': TrainingReportList,
  'training-report-show': TrainingReportShow,
  'save-training-report': SaveTrainingReport,
};
